class JwtUtils
{
    public getJWTPayload(token)
    {
        const splitToken = token.split(".");
        const payload = splitToken[1];
        const decodedPayload = atob(payload);
        return JSON.parse(decodedPayload);
    }
}

export default new JwtUtils();
